import React, { useEffect } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import DeliveryController from '../../controller/DeliveryController';
import 'react-responsive-modal/styles.css';
import '../../styles/CustomModal.css';
import toast from 'react-hot-toast';
import { DELIVERY_POINTS } from '../../utils/DataType';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  type: string;
  number: string;
  marketingCheck?: boolean;
  uuid?: string;
  setComplete?: (bVisible: boolean) => void;
};

const CheckModal = ({
  isVisible,
  setVisible,
  type,
  number,
  marketingCheck,
  uuid,
  setComplete,
}: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  const confirmAndSendPhoneNumber = async () => {
    let sUuid: any = uuid;

    try {
      const sPhoneNumber = ('' + number).replace(/\D/g, '');
      const bMarketing: any = marketingCheck;
      const response = await DeliveryController.setDeliveryPoint(sUuid, sPhoneNumber, bMarketing);

      if (response.data.ok) {
        if (response.data.data) {
          setVisible(false);
          toast.success(`${DELIVERY_POINTS}포인트가 적립되었어요\n안전운전 하세요!😄`);
          if (setComplete) {
            setComplete(true);
          }
        }
      }
    } catch (err: any) {
      console.log('err-->', err);
      toast.error(err.toString());
    }
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="checkPhoneNumModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h1>{`입력하신 ${
              type === 'account' ? '계좌번호' : '전화번호'
            }가\n맞는지 확인해주세요 😊`}</h1>
          </div>
          {type === 'account' ? (
            <div>
              <h2>김노크</h2>
              <h1>{number}</h1>
            </div>
          ) : (
            <h1 className="number">{number}</h1>
          )}
          <div className="footer">
            <button onClick={confirmAndSendPhoneNumber}>
              <h3>네, 맞아요</h3>
            </button>
            <button className="cancel" onClick={onCloseModal}>
              <h3>다시 입력할래요</h3>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CheckModal;

const Style = styled.div`
  .modal {
    height: 70vh;
    padding: 18% 5% 5% 5%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  h1 {
    line-height: 44px;
    font-weight: 600;
    text-align: left;
    color: #555555;
  }

  h2 {
    text-align: left;
    color: #555555;
    font-weight: 600;
    margin: 0;
  }
  h1.number {
    color: #4dd2ae;
    text-align: center;
  }

  button {
    margin-top: 12px;
    width: 100%;
    /*height: calc(7vh - 4px);*/
    height: 60px;
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
    }
  }

  button.cancel {
    margin-top: 8px;
    width: 100%;
    /*height: calc(7vh - 4px);*/
    height: 60px;
    background: #ffffff;
    border: 1px solid #cecece;
    border-radius: 5px;
    h3 {
      color: #979797;
    }
  }
`;
